/**
 * Device traits that survive cleared site data, a new guest id and a reinstall: support compares them
 * to find a guest's earlier account. Used only for that, never sent to ad or attribution networks.
 * relaxed - hardware and region: survives browser updates and settings changes, collides on same model devices in one timezone
 * strict - relaxed plus browser family and language list: more unique, changes with a browser switch or a new language
 */
const DeviceFingerprint = {
    RELAXED: ["os", "gpu", "screen", "pixelRatio", "cores", "memory", "timezone"],
    STRICT: ["os", "gpu", "screen", "pixelRatio", "cores", "memory", "timezone", "browser", "languages"],

    calculate: function () {
        const traits = DeviceFingerprint.collectTraits();

        return {
            relaxed: DeviceFingerprint.hash(traits, DeviceFingerprint.RELAXED),
            strict: DeviceFingerprint.hash(traits, DeviceFingerprint.STRICT),
            traits
        };
    },

    collectTraits: function () {
        const nav = window.navigator;
        const screen = window.screen || {};

        return {
            os: connector.info.os,
            gpu: DeviceFingerprint.getGpu(),
            screen: `${Math.max(screen.width, screen.height)}x${Math.min(screen.width, screen.height)}`,
            pixelRatio: Math.round((window.devicePixelRatio || 1) * 100) / 100,
            cores: nav.hardwareConcurrency || 0,
            memory: nav.deviceMemory || 0,
            timezone: DeviceFingerprint.getTimezone(),
            browser: DeviceFingerprint.getBrowser(nav.userAgent || ""),
            languages: (nav.languages || [nav.language]).join(",")
        };
    },

    // reads the engine's own context: a second WebGL context counts against Safari's context budget
    getGpu: function () {
        if (engine !== "cocos2d" || cc._renderType !== cc.game.RENDER_TYPE_WEBGL) {
            return "";
        }

        const gl = cc._renderContext;
        const info = gl.getExtension("WEBGL_debug_renderer_info");
        return gl.getParameter(info ? info.UNMASKED_RENDERER_WEBGL : gl.RENDERER) || "";
    },

    getTimezone: function () {
        try {
            return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
        } catch (e) {
            return "";
        }
    },

    // family only: the version changes with every browser update
    getBrowser: function (ua) {
        const families = [
            ["edge", /Edg\//],
            ["opera", /OPR\//],
            ["yandex", /YaBrowser\//],
            ["samsung", /SamsungBrowser\//],
            ["firefox", /Firefox\/|FxiOS\//],
            ["chrome", /Chrome\/|CriOS\//],
            ["safari", /Safari\//]
        ];

        const found = families.find((family) => family[1].test(ua));
        return found ? found[0] : "other";
    },

    hash: function (traits, keys) {
        const str = keys.map((key) => traits[key]).join("|");
        // eslint-disable-next-line no-bitwise
        return (cleverapps.hashCode(str) >>> 0).toString(16).padStart(8, "0");
    }
};
